export const it = {
  utilityModule: {
    groups: {
      data: "Dati",
      healthProtocol: "Protocollo sanitario",
    },
  },
};
